import { useEffect, useRef, useState } from "react";

// eslint-disable-next-line @typescript-eslint/ban-types
const useThrottle = (func: Function, limit: number): Function => {
  const [isThrottled, setIsThrottled] = useState(false);
  const [args, setArgs] = useState<any>();
  const timeout = useRef<NodeJS.Timeout | null>(null);
  useEffect(
    // eslint-disable-next-line func-names
    function (this: any) {
      if (args) {
        if (limit === 0) {
          setIsThrottled(false);
          func.apply(this, args);
          return;
        }
        if (!isThrottled) {
          func.apply(this, args);
          setIsThrottled(true);
          timeout.current = setTimeout(() => {
            setIsThrottled(false);
            if (timeout.current) clearTimeout(timeout.current);
          }, limit);
        }
        setArgs(undefined);
      }
    },
    [args]
  );
  return (...args: any) => {
    setArgs(args);
  };
};

export default useThrottle;

/**
 * `value`, but only updated at most once per `delay`
 */
export const useThrottledValue = <T>(value: T, delay = 200): T => {
  const [throttledValue, setThrottledValue] = useState(value);
  const [throttling, setThrottling] = useState(false);

  useEffect(() => {
    if (throttling || value === throttledValue) return;

    setThrottledValue(value);
    setThrottling(true);

    setTimeout(() => {
      setThrottling(false);
    }, delay);
  }, [value, throttling, delay]);

  return throttledValue;
};
